// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".result{font-weight:700}.close-button{position:absolute!important;right:0;top:0;z-index:200;cursor:pointer}.dialog{position:relative;padding:20px;background:#fff;border-radius:5px}", ""]);
// Exports
module.exports = exports;
